import { DELETED_BOOKIES } from '../common/constants'

export const columnMigration = function (columns) {
  const deletedBookies = DELETED_BOOKIES.map(bookie => bookie.source)
  const filteredColumns = columns.filter(c => c.source !== 'BE' && !deletedBookies.includes(c.source))
  return filteredColumns
}
